var oCargaArchivos;

//No utilizar este método dentro de la implementación del prototype
function GetCargaArchivos() {
    if (oCargaArchivos == undefined) {
        oCargaArchivos = new ObjCargaArchivos();
    }
    return oCargaArchivos;
}

function ObjCargaArchivos() {
    var that = this;

    this.CargarObjetoJSON = function (onTerminate, url) {
        $.ajax({
            dataType: "json",
            url: url,
            data: "{}",
            success: function (response) {
                var data = response;
                onTerminate(response)
            }
        });
    }

    this.CargarFicheroJSON = function (onTerminate, url) {
        $.ajax({
            type: "GET",
            url: url,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (response) {
                var data = eval(response.d);
                onTerminate(data);
            },
            error: function (response) {
                //alert('Error: ' + response);
            }
        });
    }
    this.CargarFicheroJSONDeferred = function (url) {
       return $.ajax({
            type: "GET",
            url: url,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false
        });
    }
    this.cargarFicheroHTML = function (onTerminate, url) {
        $.ajax({
            url: url,
            success: function (data) {
                onTerminate(data);
            }
        });
    }

    this.cargarFicheroHTMLDeferred = function (url) {
        return $.ajax({
            url: url
        });
    }

    this.cargarFicheroHTMLParametros = function (onTerminate, url, parAux1, parAux2) {
        $.ajax({
            url: url,
            success: function (data) {
                onTerminate(data, parAux1, parAux2);
            }
        });
    }

    this.cargarFicheroConfig = function (onTerminate, url) {
        $.ajax({
            type: "GET",
            url: url,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (response) {
                var data = response.d;
                onTerminate(data);
            },
            error: function (response) {
                //alert('Error: ' + response);
            }
        });
    }

 
    this.CargarFicheroJSONPost = function (onTerminate, url, data, auxparam1,auxparam2) {
        
        $.ajax({
            type: "POST",
            url: url,
            data:  JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (response) {
                var data = eval(response.d);
                onTerminate(data,auxparam1,auxparam2);
            },
            error: function (response) {
                //alert('Error: ' + response);
            }
        });
    }

};

ObjCargaArchivos.prototype = {
}
